import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppRouter from './app/routes/AppRouter';
import { useAuthStore } from './app/store/authStore';
import { Toaster } from '@/components/ui/Toaster';
import { PushSubscriptionSync } from '@/app/components/PushSubscriptionSync';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

function App() {
    useEffect(() => {
        const { token, user, fetchUserProfileAction } = useAuthStore.getState();
        if (token && !user) {
            fetchUserProfileAction().catch(console.error);
        }
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <PushSubscriptionSync />
            <AppRouter />
            <Toaster />
        </QueryClientProvider>
    );
}

export default App;
